<ngx-spinner
  bdColor="rgba(255, 255, 255, 0.55)"
  color="#0f172a"
  size="medium"
  type="ball-spin-clockwise"
  [fullScreen]="true">
</ngx-spinner>

@if (commonSvc.authReady) {
  <router-outlet />
} @else {
  <div class="app-loading-screen" role="status" aria-live="polite">
    <div class="app-loading-card">
      <div class="app-loading-spinner"></div>
      <p>Loading your session...</p>
    </div>
  </div>
}
